'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function tail(arr) {
    return arr.slice(1);
}

exports.tail = tail;
